import { isAllocatedToExcludedExperiment } from './conditions';
import getShouldExcludeFunc from './exclusions';
var EXCLUDE_BRAZE_DEFAULT_CONDITIONS = [isAllocatedToExcludedExperiment];

/**
 * Returns whether the user should be excluded from seeing Braze modal.
 *
 * Accepts customizable array of exclusion conditions.
 */
export var getShouldExcludeBraze = getShouldExcludeFunc(EXCLUDE_BRAZE_DEFAULT_CONDITIONS);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getShouldExcludeBraze.js
// module id = 1430
// module chunks = 11